import { tenantRepo } from "@/repositories/tenantRepo";
import { apiService } from "@/services/apiService";
import { useTenantStore } from "@/stores/tenantStore";
import type { StripeCheckoutSessionStatus } from "@repo/types";
import { Button } from "@repo/ui/components/Base/Button";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

export const VerifySubscriptionStep = () => {
  const { tenant: tenantData, setTenant } = useTenantStore();
  const [, setSearchParams] = useSearchParams();
  const [status, setStatus] = useState<StripeCheckoutSessionStatus | null>(
    null
  );
  const [customerEmail, setCustomerEmail] = useState("");
  const [customerStripeId, setCustomerStripeId] = useState("");
  const [subscriptionStripeId, setSubscriptionStripeId] = useState("");

  useEffect(() => {
    let cancel = false;

    const sessionId = new URLSearchParams(window.location.search).get(
      "session_id"
    );

    (async () => {
      const { data } = await apiService.v1.getSession(sessionId ?? "null");
      if (cancel) return;

      setStatus(data.status);
      setCustomerEmail(data.customerStripeEmail);
      setCustomerStripeId(data.customerStripeId);
      setSubscriptionStripeId(data.subscriptionStripeId);
      if (
        data.status === "complete" &&
        tenantData &&
        tenantData.subscriptionId !== data.subscriptionStripeId
      ) {
        const tenant = await tenantRepo.update(tenantData.id, {
          ownerStripeCustomerId: data.customerStripeId,
          subscriptionId: data.subscriptionStripeId,
          subscriptionStatus: "active",
        });
        setTenant(tenant);
      }
    })();

    return () => {
      cancel = true;
    };
  }, [tenantData, setTenant]);

  if (status === "open") {
    setSearchParams({ stepId: "2", tenantId: tenantData?.id ?? "" });
  }

  console.log({
    status,
    customerEmail,
    customerStripeId,
    subscriptionStripeId,
  });

  const handleComplete = async () => {
    apiService.v1.mailWelcome({ tenantId: tenantData?.id ?? "unknown" });

    setSearchParams((searchParams) => {
      searchParams.set(
        "stepId",
        `${parseInt(searchParams.get("stepId") ?? "0") + 1}`
      );
      return searchParams;
    });
  };
  if (status === "complete") {
    return (
      <section id="success" className="w-max-md-screen">
        <div>
          <p>
            We appreciate your business! A confirmation email will be sent to{" "}
            {customerEmail}. If you have any questions, please email{" "}
            <a href="mailto:contact@civi.link">contact@civi.link</a>.
          </p>
        </div>
        <div className="flex flex-row justify-end">
          <Button onClick={handleComplete}>Continue</Button>
        </div>
      </section>
    );
  }

  return null;
};
